import { t } from "@/i18n-js/instance";
import { toLocaleString } from "@circle-react/helpers/number";
import { useBillingContext } from "../BillingContext";
import { UsageDetailsSection } from "./UsageDetailsSection";
import { UsageMetric } from "./UsageMetric";

const localeRoot = "settings.billing.manage_billing.usage_details.email_hub";

export const EmailHubUsageDetails = () => {
  const { auxiliarySubscription } = useBillingContext();
  const emailHub = auxiliarySubscription?.email_hub;

  if (!emailHub?.email_hub_billing_active) {
    return null;
  }

  const {
    current_contacts_count: currentContacts,
    max_contacts_count_in_tier: maxContacts,
    percentage_completion_in_tier: progress,
    amount_with_currency: amountWithCurrency,
  } = emailHub;

  const description = t(`${localeRoot}.contacts.description`, {
    current_usage: toLocaleString(currentContacts),
    total_usage: toLocaleString(maxContacts),
  });

  return (
    <UsageDetailsSection title={t(`${localeRoot}.title`)} showMenu>
      <UsageMetric
        title={t(`${localeRoot}.contacts.title`)}
        progress={progress}
        description={description}
        price={amountWithCurrency}
      />
    </UsageDetailsSection>
  );
};
